// Government registration + trade credentials strip. Renders directly above the Footer.
export default function CredentialsBar() {
  const items = [
    { label: "GSTIN", value: "29AAEHN0680H1Z3" },
    { label: "Udyam Reg. No.", value: "UDYAM-KR-03-0064205" },
    { label: "Member", value: "Bangalore Wholesale Cloth Merchants Assn." },
  ];
  return (
    <section
      className="border-y"
      style={{
        backgroundColor: "var(--mp-paper)",
        borderColor: "rgba(160,71,39,0.2)",
      }}
      data-testid="credentials-bar"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-8">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 items-center text-center">
          {items.map((it, idx) => (
            <div key={it.label} className={`${idx > 0 ? "sm:border-l" : ""}`} style={{ borderColor: "rgba(160,71,39,0.15)" }}>
              <p
                className="text-[10px] uppercase tracking-[0.28em] font-semibold mb-2"
                style={{ fontFamily: "'Manrope', sans-serif", color: "var(--mp-copper)" }}
              >
                {it.label}
              </p>
              <p
                className="text-sm lg:text-base font-medium"
                style={{ fontFamily: "'Cormorant Garamond', serif", color: "var(--mp-text)", letterSpacing: "0.03em" }}
                data-testid={`credential-${it.label.toLowerCase().replace(/[^a-z0-9]/g, "-")}`}
              >
                {it.value}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
